export const FILTER_TYPES = {
  THEMATIC: 'thematic',
  NORMAL: 'normal',
  RELATED: 'related',
};
